<template>
  <div v-if="modalVisible" class="float-modal-container"
    :class="{ 'float-modal-mini': isMini, 'float-modal-top': isTop }" :style="containerStyle" ref="modalRef">
    <div v-if="!isMini" class="float-modal-header" @mousedown="startDrag">
      <span class="float-modal-title">{{ title }}</span>
      <div class="float-modal-controls">
        <el-tooltip class="item" effect="dark" :content="$t('floatModal.mini')" placement="top">
          <img :src="oss_url + 'icon_modal_xck.png'" style="height: 16px; cursor: pointer" @click.stop="toggleMini" />
        </el-tooltip>

        <el-tooltip v-if="isTop" effect="dark" :content="$t('floatModal.cancelTop')" placement="top">
          <img :src="oss_url + 'icon_affix_fill1.png'" style="height: 18px; cursor: pointer" @click.stop="toggleTop" />
        </el-tooltip>

        <el-tooltip v-else effect="dark" :content="$t('floatModal.setTop')" placement="top">
          <img :src="oss_url + 'icon_affix.png'" style="height: 18px; cursor: pointer" @click.stop="toggleTop" />
        </el-tooltip>

        <el-tooltip v-if="isFull" class="item" effect="dark" :content="$t('floatModal.exitFullscreen')" placement="top">
          <img :src="oss_url + 'icon-full-cancel.png'" style="height: 16px; cursor: pointer" @click.stop="toggleFull" />
        </el-tooltip>

        <el-tooltip v-else class="item" effect="dark" :content="$t('floatModal.fullscreen')" placement="top">
          <img :src="oss_url + 'icon-full-active.png'" style="height: 16px; cursor: pointer" @click.stop="toggleFull" />
        </el-tooltip>


        <el-tooltip class="item" effect="dark" :content="$t('floatModal.close')" placement="top">
          <i class="el-icon-close" @click.stop="close"></i>
        </el-tooltip>
      </div>
    </div>
    <div class="float-modal-content" ref="resizeRef" @mouseenter="showMiniClose = true"
      @mouseleave="showMiniClose = false">
      <slot></slot>
      <div v-if="isMini && showMiniClose" class="mini-close-btns">

        <el-tooltip class="item" effect="dark" :content="$t('floatModal.restoreWindow')" placement="top">
          <img :src="oss_url + 'icon_modal_dck.png'" style="height: 16px; width: 16px;" class="mini-control-btn"
            @click.stop="toggleMini" />
        </el-tooltip>

        <el-tooltip v-if="isTop" effect="dark" :content="$t('floatModal.cancelTop')" placement="top">
          <img :src="oss_url + 'icon_affix_fill1.png'" class="mini-control-btn" @click.stop="toggleTop" />
        </el-tooltip>

        <el-tooltip v-else effect="dark" :content="$t('floatModal.setTop')" placement="top">
          <img :src="oss_url + 'icon_affix.png'" class="mini-control-btn" @click.stop="toggleTop" />
        </el-tooltip>

        <el-tooltip effect="dark" :content="$t('floatModal.close')" placement="top">
          <img :src="oss_url + 'icon_modal_gb.png'" class="mini-control-btn" @click.stop="close" />
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'FloatModal',
  props: {
    title: {
      type: String,
      default: ''
    },
    defaultWidth: {
      type: Number,
      default: 720
    },
    defaultHeight: {
      type: Number,
      default: 400
    },
    minWidth: {
      type: Number,
      default: 300
    },
    minHeight: {
      type: Number,
      default: 200
    }
  },
  data() {
    return {
      posX: 0,
      posY: 0,
      width: this.defaultWidth,
      height: this.defaultHeight,
      isDragging: false,
      isResizing: false,
      resizeDirection: 'se',
      dragStartX: 0,
      dragStartY: 0,
      elementStartX: 0,
      elementStartY: 0,
      resizeStartX: 0,
      resizeStartY: 0,
      resizeStartWidth: 0,
      resizeStartHeight: 0,
      showMiniClose: false
    };
  },
  computed: {
    ...mapState('floatModal', {
      modalVisible: 'modalVisible',
      isTop: 'isTop',
      isFull: 'isFull',
      isMini: 'isMini'
    }),
    containerStyle() {
      if (this.isFull) {
        return {
          left: '0',
          top: '0',
          width: '100vw',
          height: '100vh',
          zIndex: 9999
        };
      }
      if (this.isMini) {
        return {
          left: 'auto',
          right: '20px',
          bottom: '20px',
          top: 'auto',
          width: '360px',
          height: '200px',
          zIndex: this.isTop ? 99999 : 9999
        };
      }
      return {
        left: this.posX + 'px',
        top: this.posY + 'px',
        width: this.width + 'px',
        height: this.height + 'px',
        zIndex: this.isTop ? 99999 : 9999
      };
    }
  },
  watch: {
    modalVisible(newVal) {
      if (newVal) {
        this.initPosition();
      }
    }
  },
  mounted() {
    document.addEventListener('mousemove', this.onDrag);
    document.addEventListener('mouseup', this.stopDrag);
    document.addEventListener('mousemove', this.onResize);
    document.addEventListener('mouseup', this.stopResize);
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.onDrag);
    document.removeEventListener('mouseup', this.stopDrag);
    document.removeEventListener('mousemove', this.onResize);
    document.removeEventListener('mouseup', this.stopResize);
  },
  methods: {
    initPosition() {
      const containerWidth = window.innerWidth;
      const containerHeight = window.innerHeight;
      this.posX = Math.floor((containerWidth - this.defaultWidth) / 2);
      this.posY = Math.floor((containerHeight - this.defaultHeight) / 2) - 60;
      this.width = this.defaultWidth;
      this.height = this.defaultHeight;
    },

    startDrag(e) {
      if (this.isMini || this.isFull) return;
      this.isDragging = true;
      this.dragStartX = e.clientX;
      this.dragStartY = e.clientY;
      this.elementStartX = this.posX;
      this.elementStartY = this.posY;
    },

    onDrag(e) {
      if (!this.isDragging) return;
      const dx = e.clientX - this.dragStartX;
      const dy = e.clientY - this.dragStartY;
      this.posX = this.elementStartX + dx;
      this.posY = this.elementStartY + dy;
    },

    stopDrag() {
      this.isDragging = false;
    },

    startResize(e, direction = 'se') {
      if (this.isMini || this.isFull) return;
      this.isResizing = true;
      this.resizeDirection = direction;
      this.resizeStartX = e.clientX;
      this.resizeStartY = e.clientY;
      this.resizeStartWidth = this.width;
      this.resizeStartHeight = this.height;
      this.elementStartX = this.posX;
      this.elementStartY = this.posY;
    },

    onResize(e) {
      if (!this.isResizing) return;
      const dx = e.clientX - this.resizeStartX;
      const dy = e.clientY - this.resizeStartY;
      const dir = this.resizeDirection;

      if (dir.includes('e')) {
        this.width = Math.max(this.minWidth, this.resizeStartWidth + dx);
      }
      if (dir.includes('s')) {
        this.height = Math.max(this.minHeight, this.resizeStartHeight + dy);
      }
      if (dir.includes('w')) {
        const newWidth = this.resizeStartWidth - dx;
        if (newWidth >= this.minWidth) {
          this.width = newWidth;
          this.posX = this.elementStartX + dx;
        }
      }
      if (dir.includes('n')) {
        const newHeight = this.resizeStartHeight - dy;
        if (newHeight >= this.minHeight) {
          this.height = newHeight;
          this.posY = this.elementStartY + dy;
        }
      }
    },

    stopResize() {
      this.isResizing = false;
    },

    toggleFull() {
      this.$store.dispatch('floatModal/toggleFull');
    },

    toggleMini() {
      this.$store.dispatch('floatModal/toggleMini');
    },

    toggleTop() {
      this.$store.dispatch('floatModal/toggleTop');
    },

    close() {
      this.$store.dispatch('floatModal/closeModal');
    }
  }
};
</script>

<style lang="scss" scoped>
.float-modal-container {
  position: fixed;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid #303440;

  &.float-modal-mini {
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.02);
      box-shadow: 0 6px 24px rgba(0, 0, 0, 0.2);
    }
  }

  &.float-modal-top {
    box-shadow: 0 4px 20px rgba(255, 0, 0, 0.2);
  }
}

.float-modal-header {
  height: 40px;
  background: #5470c6; // linear-gradient(135deg, #1890ff, #40a9ff);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  cursor: move;
  user-select: none;

  &:active {
    cursor: grabbing;
  }
}

.float-modal-title {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.float-modal-controls {
  display: flex;
  align-items: center;
  gap: 8px;

  i {
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    transition: all 0.2s;
    opacity: 0.8;

    &:hover {
      opacity: 1;
      background: rgba(255, 255, 255, 0.2);
    }

    &.active {
      color: #ffd700;
      opacity: 1;
    }
  }
}

.float-modal-content {
  flex: 1;
  overflow: hidden;
  cursor: se-resize;
  position: relative;
}

.mini-control-btn {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.mini-close-btns {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  gap: 8px;
  z-index: 100;
  align-items: center;
}

.float-modal-mini-bar {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1890ff, #40a9ff);
  cursor: pointer;

  &:hover {
    background: linear-gradient(135deg, #40a9ff, #69c0ff);
  }
}

.mini-indicator {
  color: #fff;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 6px;

  i {
    font-size: 18px;
  }
}

.resize-handle {
  position: absolute;
  z-index: 10;
}

.resize-handle-n,
.resize-handle-s {
  left: 10px;
  right: 10px;
  height: 8px;
  cursor: ns-resize;
}

.resize-handle-n {
  top: -4px;
}

.resize-handle-s {
  bottom: -4px;
}

.resize-handle-e,
.resize-handle-w {
  top: 10px;
  bottom: 10px;
  width: 8px;
  cursor: ew-resize;
}

.resize-handle-e {
  right: -4px;
}

.resize-handle-w {
  left: -4px;
}

.resize-handle-ne,
.resize-handle-nw,
.resize-handle-se,
.resize-handle-sw {
  width: 16px;
  height: 16px;
}

.resize-handle-ne {
  top: -4px;
  right: -4px;
  cursor: nesw-resize;
}

.resize-handle-nw {
  top: -4px;
  left: -4px;
  cursor: nesw-resize;
}

.resize-handle-se {
  bottom: -4px;
  right: -4px;
  cursor: nwse-resize;
}

.resize-handle-sw {
  bottom: -4px;
  left: -4px;
  cursor: nwse-resize;
}
</style>